import { REQUEST_METHOD } from '@/constants';
import { API_ENDPOINTS } from '@/constants/api-endpoints';
import { ILinkOption, IUpdateLinkOptionBody } from '@/types/page-cta';
import { apiInstance } from '@/utils';

export const updateLinkOptions = async (data: IUpdateLinkOptionBody) => {
  const result = await apiInstance({
    method: REQUEST_METHOD.POST,
    data,
    url: API_ENDPOINTS.updateLinkOptions,
  });

  return result.data;
};

export const getLinkOptions = async (linkId: string | number): Promise<ILinkOption> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.GET,
    url: API_ENDPOINTS.getLinkOptions(linkId),
  });

  return result.data;
};

export const generateCloudFlareUploadVideoUrl = async (
  fake: string,
): Promise<{ uploadUrl: string }> => {
  const result = await apiInstance({
    method: REQUEST_METHOD.GET,
    url: API_ENDPOINTS.generateCloudFlareUploadVideoUrl,
  });

  return result.data;
};
